
export class DisbursementReportDataModel {

    // Gets or sets the customer display name
    public customerDisplayName: string;

    // Gets or sets the customer account number id
    public customerAccountNumberId: number;

    // Gets or sets the amount
    public amount: number;

    // Gets or sets the order number
    public orderNumber: number;

    // Gets or sets the authorization code
    public authorizationCode: string;

    constructor(json: any) {
        if (json) {
            this.customerDisplayName = json.customerDisplayName;
            this.customerAccountNumberId = json.customerAccountNumberId;
            this.amount = json.amount;
            this.orderNumber = json.orderNumber;
            this.authorizationCode = json.authorizationCode;
        }
    }
}
